// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"9263bcc0","861":"e7523585"}[chunkId] + ".chunk.css";
};